/**
 * ドライバー指示メモ
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'
import manifest_maintenance_collection_report from "./collection_report";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests`

 const manifest_maintenance_driver_instruction = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/driver_instructions`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { id, params }) {
      const api_path = `${API_PATH}/${id}/driver_instructions`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params, { headers: { 'content-type': 'multipart/form-data'}}).then( data => {
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(data.content)
        } )
      })
    },

  },
  mutations: {},

 }

 export default manifest_maintenance_driver_instruction
